module.exports = __webpack_public_path__ + "img/certification.d0f61eb2.png";